module.exports = {
    menus:["qiye", "orderrecord", 'billCenter']
}
